import React from 'react';
import SuccessBody from '../SuccessBody/SuccessBody';

const Success = () => {
    return (
        <div>
           <SuccessBody /> 
        </div>
    );
};

export default Success;